import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './langs/zh_CN'
import en from './langs/en_US'

import setLocale from "./changeLang";

Vue.use(VueI18n)

// window.ChineseDictionary = require('./langs/ChineseDictionary').default

const messages = {
  en,
  zh
}

if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', 'zh');
}

window.$i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages
})

window.$i8 = (str) => {
  return $i18n.t(str)
}
Vue.prototype.$i8 = (str) => {
  return $i18n.t(str)
}

window.$i18n['lang'] = (v,x) => {
  setLocale(v,x)
};

export default $i18n
